import React from 'react';
import { Link } from 'react-router-dom';
import { OpenFormButton } from '../ContactForm'

export default (props) => {
    const year = new Date().getFullYear();
    return (
        <footer>

            <div className="footer-left">
                <h1><Link to="/"><img src="/images/blueshyft-logo.svg" /></Link></h1>
                {/* <p>Shore Studios, Level 3</p>
                <p>17/13 Hickson Road</p>
                <p>Dawes Point NSW 2000</p> */}
                <p className="all-rights">All rights reserved © Blueshyft Pty Ltd {year}</p>
            </div>

            <div className="footer-right">

                <div className="vertical-menu">
                    <p>BLUESHYFT</p>
                    <Link to="/">Home</Link>
                    <Link to="/about">About Us</Link>
                    <Link to="/terms">Terms & Conditions</Link>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <a href="http://status.blueshyft.com.au" target="_blank">Status</a>
                </div>

                <div className="vertical-menu">
                    <p>LEARN MORE</p>
                    <a href="https://locations.blueshyft.com.au" target="_blank">Browse Network</a>
                    <Link to="/clients">Our Clients</Link>
                </div>

                <div className="vertical-menu">
                    <p>LET'S TALK</p>
                    <OpenFormButton>Contact Form</OpenFormButton>
                    <div className="socials">
                        <a href="https://twitter.com/blueshyft" target="_blank"><img src="/images/new/icons/twitter.svg" /></a>
                        <a href="https://www.facebook.com/blueshyft/" target="_blank"><img src="/images/new/icons/facebook.svg" /></a>
                        <a href="https://www.linkedin.com/company/blueshyft/" target="_blank"><img src="/images/new/icons/linkedin.svg" /></a>
                    </div>
                </div>

            </div>

        </footer>
    );
};



// WEBPACK FOOTER //
// ./client/components/Footer/index.js